const appLocale = (document.body && document.body.dataset && document.body.dataset.locale) || "ja";
const i18n = window.I18n || { t: (key) => key };
const TAG_CLASS_MAP = {
  [i18n.t("search.events.tag-live")]: "tag-01",
  [i18n.t("search.events.tag-streaming")]: "tag-02",
  [i18n.t("search.events.tag-free-streaming")]: "tag-03",
  [i18n.t("search.events.tag-member-free")]: "tag-04",
};

function withLocale(url) {
  const parsedUrl = new URL(url, window.location.origin);
  if (!parsedUrl.searchParams.has("locale")) {
    parsedUrl.searchParams.set("locale", appLocale);
  }
  return `${parsedUrl.pathname}${parsedUrl.search}`;
}

async function fetchJson(url) {
  const response = await fetch(withLocale(url), {
    credentials: "same-origin",
    headers: { Accept: "application/json" },
  });

  if (!response.ok) {
    throw new Error(`Request failed: ${response.status}`);
  }

  return response.json();
}

function normalizeImageUrl(url) {
  if (!url) return "";
  return url;
}

function setBackgroundImage(element, url) {
  if (!element || !url) return;

  element.style.backgroundImage = `url("${String(url).replace(/"/g, '\\"')}")`;
}

function hideSection(section) {
  if (section) section.hidden = true;
}

function showSection(section) {
  if (section) section.hidden = false;
}

function tagClassFor(tag) {
  return TAG_CLASS_MAP[tag] || "";
}

function createTagGroup(tags) {
  const tagGroup = document.createElement("div");
  tagGroup.className = "tag-group";

  (tags || []).forEach((tag) => {
    const span = document.createElement("span");
    span.className = ["tag", tagClassFor(tag)].filter(Boolean).join(" ");
    span.textContent = tag;
    tagGroup.appendChild(span);
  });

  return tagGroup;
}

function createEventCard(event) {
  const item = document.createElement("li");
  const article = document.createElement("article");
  const link = document.createElement("a");
  const card = document.createElement("div");
  const thumb = document.createElement("div");
  const thumbInner = document.createElement("div");
  const desc = document.createElement("div");
  const title = document.createElement("h1");
  const meta = document.createElement("div");
  const category = document.createElement("span");
  const date = document.createElement("span");
  const time = document.createElement("span");
  const caption = document.createElement("span");
  const imageUrl = normalizeImageUrl(event.image_url);

  link.href = event.url || `/events/${event.id}`;
  card.className = "card";
  thumb.className = "thum";
  thumbInner.className = "inner";
  desc.className = "desc";
  title.className = "title";
  meta.className = "meta";
  category.className = "category";
  date.className = "date";
  time.className = "time";
  caption.className = "caption";

  setBackgroundImage(thumb, imageUrl);
  setBackgroundImage(thumbInner, imageUrl);

  title.textContent = event.title || "";
  category.textContent = event.category_label || "";
  category.style.display = event.category_label ? "block" : "none";
  date.textContent = event.begin_date || "";
  time.textContent = event.open_start || "";
  caption.textContent = [event.prefecture_name, event.space_name].filter(Boolean).join(" ");

  meta.appendChild(category);
  meta.appendChild(date);
  meta.appendChild(time);
  meta.appendChild(caption);
  desc.appendChild(title);
  desc.appendChild(meta);
  thumb.appendChild(thumbInner);
  card.appendChild(createTagGroup(event.tags));
  card.appendChild(thumb);
  card.appendChild(desc);
  link.appendChild(card);
  article.appendChild(link);
  item.appendChild(article);

  return item;
}

function renderEventCards(container, events, replace) {
  if (!container) return;
  const isAsyncSlider = container.classList.contains("js-slick-sub")
    && window.jQuery
    && typeof window.jQuery.fn.slick === "function";

  if (replace && isAsyncSlider && container.classList.contains("slick-initialized")) {
    window.jQuery(container).slick("unslick");
  }

  if (replace) container.innerHTML = "";

  const fragment = document.createDocumentFragment();
  events.forEach((event) => {
    fragment.appendChild(createEventCard(event));
  });
  container.appendChild(fragment);

  if (isAsyncSlider) {
    window.jQuery(document).trigger("omatsuri:refresh-slick");
  }
}

function truncateText(text, length) {
  const value = text || "";
  return value.length > length ? `${value.substring(0, length - 3)}...` : value;
}

function createCircleItem(item) {
  const listItem = document.createElement("li");
  const link = document.createElement("a");
  const article = document.createElement("article");
  const thumb = document.createElement("div");
  const image = document.createElement("div");
  const name = document.createElement("div");
  const label = item.name || "";
  const imageUrl = item.thumbnail_image_url || item.stream_image_url || item.image_url;

  link.href = item.url || `/search?search[keyword]=${encodeURIComponent(label)}`;
  link.className = "wrap-block-link";
  thumb.className = "thum";
  image.className = "image";
  name.className = "name";
  name.textContent = truncateText(label, 30);
  setBackgroundImage(image, imageUrl);

  thumb.appendChild(image);
  article.appendChild(thumb);
  article.appendChild(name);
  link.appendChild(article);
  listItem.appendChild(link);

  return listItem;
}

function renderCircleItems(container, items) {
  if (!container) return;

  container.innerHTML = "";
  const fragment = document.createDocumentFragment();
  items.forEach((item) => {
    fragment.appendChild(createCircleItem(item));
  });
  container.appendChild(fragment);
}

function renderCategories(categories) {
  const section = document.querySelector("[data-home-categories-section]");
  const container = document.querySelector("[data-home-categories]");
  if (!section || !container) return;

  if (!categories || !categories.length) {
    hideSection(section);
    return;
  }

  container.innerHTML = "";
  const fragment = document.createDocumentFragment();

  for (let index = 0; index < categories.length; index += 2) {
    const listItem = document.createElement("li");
    categories.slice(index, index + 2).forEach((category) => {
      const article = document.createElement("article");
      const link = document.createElement("a");
      const block = document.createElement("div");
      const name = document.createElement("h1");

      link.href = category.url || `/search?search[keyword]=${encodeURIComponent(category.name || "")}`;
      link.className = "wrap-block-link";
      block.className = ["block", category.color_class].filter(Boolean).join(" ");
      name.className = "name";
      name.textContent = category.name || "";

      block.appendChild(name);
      link.appendChild(block);
      article.appendChild(link);
      listItem.appendChild(article);
    });
    fragment.appendChild(listItem);
  }

  container.appendChild(fragment);
  showSection(section);
}

function renderPickupCard(template, event) {
  const card = template.content.firstElementChild.cloneNode(true);
  const link = card.querySelector(".pickup-card-link");
  const blur = card.querySelector(".thumb-blur-bg");
  const image = card.querySelector(".thumb-main-img");
  const tag = card.querySelector(".pickup-tag");
  const title = card.querySelector(".pickup-title");
  const recommendation = card.querySelector("[data-pickup-recommend]");
  const date = card.querySelector("[data-pickup-date]");
  const venue = card.querySelector("[data-pickup-venue]");
  const button = card.querySelector(".pickup-btn");
  const imageUrl = normalizeImageUrl(event.image_url);

  link.href = event.url || `/events/${event.id}`;
  blur.src = imageUrl;
  blur.alt = "";
  image.alt = event.title || "";
  image.src = imageUrl;
  tag.textContent = (event.tags || [])[0] || "ライブ";
  title.textContent = event.title || "";
  recommendation.textContent = event.store_recommendation_text || event.category_label || "ライブハウスのおすすめイベントです。";
  date.textContent = event.begin_date || "";
  venue.textContent = [event.prefecture_name, event.space_name].filter(Boolean).join(" ");
  button.textContent = event.ticket_cta_label || "詳細を見る";

  return card;
}

async function initHomeMeta() {
  const root = document.querySelector("[data-home-root]");
  if (!root || !root.dataset.homeUrl) return;

  const data = await fetchJson(root.dataset.homeUrl);

  renderCategories(data.categories || []);
}

async function initTopPickup() {
  const section = document.querySelector("[data-top-pickup]");
  if (!section) return;

  const container = section.querySelector("[data-pickup-scroll]");
  const template = document.getElementById("pickup-card-template");
  const prev = section.querySelector("[data-pickup-prev]");
  const next = section.querySelector("[data-pickup-next]");
  const url = section.dataset.eventsUrl;

  try {
    const events = await fetchJson(url);
    container.innerHTML = "";

    if (!events.length) {
      container.innerHTML = '<li class="pickup-loading">表示できるライブがありません。</li>';
      return;
    }

    events.forEach((event) => {
      container.appendChild(renderPickupCard(template, event));
    });
  } catch (error) {
    container.innerHTML = '<li class="pickup-loading">ライブ情報を取得できませんでした。</li>';
  }

  const scrollByCard = (direction) => {
    const card = container.querySelector(".pickup-card");
    const distance = card ? card.getBoundingClientRect().width + 15 : 360;
    container.scrollBy({ left: direction * distance, behavior: "smooth" });
  };

  prev.addEventListener("click", () => scrollByCard(-1));
  next.addEventListener("click", () => scrollByCard(1));
}

async function loadSimpleSection(section) {
  const container = section.querySelector("[data-home-list]");
  const items = await fetchJson(section.dataset.endpoint);

  if (!items.length) {
    hideSection(section);
    return;
  }

  renderCircleItems(container, items);
  showSection(section);
}

async function loadEventSection(section) {
  const container = section.querySelector("[data-home-list]");
  const events = await fetchJson(section.dataset.endpoint);

  if (!events.length) {
    hideSection(section);
    return;
  }

  renderEventCards(container, events, true);
  showSection(section);
}

function setUpcomingLoading(section, isLoading) {
  const loader = section.querySelector("[data-home-loader]");
  if (loader) loader.style.display = isLoading ? "block" : "none";
}

function setUpcomingMoreButton(section, show) {
  const button = section.querySelector("[data-home-more]");
  if (button) button.style.display = show ? "block" : "none";
}

async function loadUpcomingSection(section, pageNumber) {
  const state = section._homePagination || { current: 0, total: null, isLoading: false };
  if (state.isLoading) return;

  state.isLoading = true;
  section._homePagination = state;
  setUpcomingMoreButton(section, false);
  setUpcomingLoading(section, true);

  try {
    const url = new URL(section.dataset.endpoint, window.location.origin);
    url.searchParams.set("page", pageNumber);
    url.searchParams.set("locale", appLocale);

    const response = await fetch(`${url.pathname}${url.search}`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });

    if (!response.ok) {
      throw new Error(`Request failed: ${response.status}`);
    }

    const events = await response.json();
    state.current = parseInt(response.headers.get("Current-Page"), 10) || pageNumber;
    state.total = parseInt(response.headers.get("Total-Pages"), 10) || state.current;

    if (!events.length && state.current === 1) {
      hideSection(section);
      return;
    }

    renderEventCards(section.querySelector("[data-home-list]"), events, state.current === 1);
    showSection(section);
    setUpcomingMoreButton(section, state.current < state.total);
  } catch (error) {
    if (state.current === 0) hideSection(section);
  } finally {
    state.isLoading = false;
    setUpcomingLoading(section, false);
  }
}

function initUpcomingSection(section) {
  if (section._homeInitialized) return;

  section._homeInitialized = true;
  const button = section.querySelector("[data-home-more]");
  if (button) {
    button.addEventListener("click", () => {
      const state = section._homePagination || { current: 1, total: null, isLoading: false };
      if (state.total && state.current >= state.total) return;
      loadUpcomingSection(section, state.current + 1);
    });
  }
}

async function loadLazySection(section) {
  const kind = section.dataset.homeKind;

  try {
    if (kind === "artists" || kind === "spaces") {
      await loadSimpleSection(section);
      return;
    }

    if (kind === "upcoming-events") {
      initUpcomingSection(section);
      await loadUpcomingSection(section, 1);
      return;
    }

    await loadEventSection(section);
  } catch (error) {
    hideSection(section);
  }
}

function initLazySections() {
  const sections = Array.from(document.querySelectorAll("[data-lazy-section]"));

  if (!("IntersectionObserver" in window)) {
    sections.forEach((section) => loadLazySection(section));
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      observer.unobserve(entry.target);
      loadLazySection(entry.target);
    });
  }, { rootMargin: "320px 0px" });

  sections.forEach((section) => observer.observe(section));
}

document.addEventListener("DOMContentLoaded", () => {
  Promise.allSettled([initHomeMeta(), initTopPickup()]).finally(initLazySections);
});
